import { useState } from "react"
import img1 from "../assets/WhatsApp Image 2023-09-09 at 10.01.32 AM (2).jpeg"


const MemberComponent = ({ v, i }) => {

    const [images, setImages] = useState([img1, img1, img1, img1, img1])

    return (
        <>
            <div className="animate__animated  animate__fadeInLeft animate__delay-1s lg:w-1/3 h-36 lg:h-auto py-4 max-w-full max-h-full rounded-[6px] mb-[200px] mt-4 w-[350px] mx-2 my-2" >
                <div className="flex items-center py-4">
                    <img
                        src={images[i]}
                        alt="volumters"
                        className="h-[140px] w-[140px] m-auto object-cover rounded-[50%] z-[11] border-2 border-orange-400"
                    />
                </div>
                <div className="px-3 py-10 text-center h-[250px]  mt-[-60px] z-[00] bg-gray-100 rounded-sm border-gray-200">
                    <h1 className="text-[24px] font-bold py-4">{v?.fullname}</h1>
                    <p className="font-normal pt-2">
                        une suite de mots sans signification utilisée à titre provisoire pour calibrer une mise en page
                    </p>
                </div>
            </div>
        </>
    )
}

export default MemberComponent